import React from 'react';
import { Box, Typography, Avatar, Divider, CircularProgress } from '@mui/material';

const StoreHeader = ({ store }) => {
  console.log(store)
    return (
        <Box sx={{ textAlign: 'center', mb: 3 }}>
            {!store ? (
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                    <CircularProgress size={20} />
                    <Typography variant="body1" color="text.secondary">
                        Cargando información de la tienda
                    </Typography>
                </Box>
            ) : (
                <Box>
                    <Avatar
                        src={store.profileImageUrl}
                        alt={store.name}
                        sx={{ 
                            width: 80, 
                            height: 80, 
                            mx: 'auto', 
                            mb: 2,
                            boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                        }}
                    />
                    <Typography variant="h4" component="h1" gutterBottom>
                        {store.name}
                    </Typography>
                    <Divider sx={{ my: 2 }} />
                </Box>
            )}
        </Box>
    );
};

export default StoreHeader;
